import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, of, take } from 'rxjs';
import { Router } from '@angular/router';

import { PortalLeadNode } from '@app/services/api/api.types';
import { ApiService } from '@app/services/api/api.service';
import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalRoutes } from '@app/app-routing.module';
import { PortalTrackingEvents } from '@app/utils/tracking-events';

@Injectable({
  providedIn: 'root',
})
export class PortalLeadService {
  portalLead$$ = new BehaviorSubject<PortalLeadNode | null>(null);

  get portalLead$() {
    return this.portalLead$$.asObservable();
  }

  constructor(
    private apiService: ApiService,
    private router: Router,
  ) {}

  getPortalLead(variables: { portalLink: string }) {
    return this.apiService
      .portalLead(variables)
      .pipe(
        take(1),
        map((response) => {
          if (!response || response.errors?.length) {
            void this.router.navigate([`/${PortalRoutes.NotFound}`]);
          }
          return response.portalLead;
        }),
        catchError(() => {
          Tracking.track(PortalTrackingEvents.portalLeadRequestError);
          return of(null);
        }),
      )
      .subscribe((portalLead) => this.setPortalLead(portalLead));
  }

  setPortalLead(portalLead: PortalLeadNode | null) {
    Tracking.patch({
      leadPortalLink: portalLead?.portalLink,
      frPortalLink: portalLead?.flightRequest?.portalLink,
    });

    return this.portalLead$$.next(portalLead);
  }
}
